import { render, staticRenderFns } from "./financialStatistics.vue?vue&type=template&id=ca8b7468&scoped=true&"
import script from "./financialStatistics.vue?vue&type=script&lang=js&"
export * from "./financialStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b7468",
  null
  
)

export default component.exports